module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vmusc14-17ee9e3ec76fbc3e8439c442c3817f43.jpg";